import ListArea from './ListArea'

export default ListArea